// This file was auto-generated by Fern from our API Definition.
/** The encoding of the computed signature. */
const WebhookSignatureEncodingValues = {
    Base64: "BASE64",
    Hex: "HEX",
};
export const WebhookSignatureEncoding = Object.assign(Object.assign({}, WebhookSignatureEncodingValues), { _visit: (value, visitor) => {
        switch (value) {
            case WebhookSignatureEncoding.Base64:
                return visitor.base64();
            case WebhookSignatureEncoding.Hex:
                return visitor.hex();
            default:
                return visitor._other();
        }
    } });
